<template>
<div>
  <vue-headful :title="site_title" />
  <Header :inProfile="true" />

  <!-- awards popup -->
  <DraggableDiv id="thread__awards" style="display: none;">
    <template slot="header">
      <div class="awards_drag" style="cursor: move;" title="Нажмите и задержите для перемещения этого окна">
        <div style="float: right;"><a class="a__uninteractable" href="javascript: dummy()" title="Закрыть окно" @click.prevent="hideAwardsPopup()">[X]</a></div>
        <div>Награды</div>
      </div>
    </template>
    <template slot="main">
      <div id="awards_content">
        <div class="awards_drag">
          <template v-if="awardsname && awardsname.length > 0">
            {{htmlDecode(awardsname)}}
          </template>
        </div>
        <table class="awards_table" width="100%">
          <tbody>
            <tr>
              <th class="suppress_right_border" width="25%" nowrap="" align="center">Награда</th>
              <th class="suppress_right_border" width="30%" nowrap="" align="center">Изображение</th>
              <th width="45%" nowrap="" align="center">Описание</th>
            </tr>
            <template v-if="awards">
              <template v-for="(award, index) in awards.awards">
                <tr v-bind:class="{suppress_bottom_border: index < awards.awards.length-1}">
                  <td class="awards_row suppress_right_border" align="center"><b>{{htmlDecode(award.awardtitle)}}</b></td>
                  <td class="awards_row suppress_right_border" align="center"><img :src="publicPath + 'html/awards/' + award.awardimg"></td>
                  <td class="awards_row" align="left">{{htmlDecode(award.description)}}</td>
                </tr>
              </template>
            </template>
            <template v-else>
              <tr>
                <td colspan="3" style="text-align: center;">
                  Загрузка наград...
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </template>
  </DraggableDiv>

  <!-- profile -->
  <template v-if="response && response.profile && footerReady">
    <div class="profile__borderwrap">
      <div class="profile__tableheader">
        <img src="../assets/nav_m.gif" /> Просмотр профиля: {{htmlDecode(response.profile.name)}}
      </div>
      <table class="profile__table" width="100%">
        <tr>
          <td width="50%">
            <div class="profile__name">{{htmlDecode(response.profile.name)}}</div>
            <!-- avatar -->
            <div class="profile__avatar">
              <template v-if="response.profile.avatar !== null && response.profile.avatar.length > 0 && response.profile.avatar !== 'noavatar'">
                <img class="avatar" :src="fixAvatarPath(response.profile.avatar)" />
              </template>
            </div>
            <!-- title -->
            <div>
              <template v-if="response.profile.title !== null && response.profile.title.length> 0">{{htmlDecode(response.profile.title)}}</template> <!-- custom title -->
              <template v-else>{{getTitleFromPosts(response.profile.posts)}}</template> <!-- normal title -->
            </div>
            <div class="profile__pips">
              <img v-for="n in getPipsFromPosts(response.profile.posts)" src="../assets/pip.gif" :alt="n | consumeN">
            </div>
            <br>
            <div>Группа: {{response.profile.citizenship}}</div>
            <div>Регистрация: {{response.profile.joined | formatRusDateShort}}</div>
          </td>
          <td width="50%" align="right">Фото</td>
        </tr>
      </table>
    </div>

    <br>
    <div class="profile__flex">
      <div class="profile__borderwrap profile__flex_child">
        <div class="profile__tableheader profile__smallerheader">
          Статистика активности
        </div>
        <table class="profile__table profile__table1" width="100%">
          <tr>
            <td valign="top"><b>Часовой пояс пользователя</b></td>
            <td>{{new Date().getTime() + (response.profile.time_offset*60*60*1000) | formatUtcDate}}</td>
          </tr>
          <tr>
            <td valign="top"><b>Всего полезных сообщений</b></td>
            <td>
              <b>{{response.profile.posts | formatInt}}</b><br>
              ( {{(response.profile.posts / ((1160881200 - response.profile.joined) / 60 / 60 / 24)).toFixed(1)}} сообщений в день
              / {{(response.profile.realposts / 360652 * 100).toFixed(2)}}% всех сообщений форума )
            </td>
          </tr>
          <tr>
            <td valign="top"><b>Создал топиков</b></td>
            <td><b>{{response.profile.topics}}</b></td>
          </tr>
          <tr>
            <td valign="top"><b>Наибольшая активность в</b></td>
            <td><b><a :href="'index.php?showforum='+response.profile.favorite_forumid">{{response.profile.favorite_forumname}}</a></b><br>
              ( {{response.profile.posts_in_favoriteforum}} сообщений / {{Math.round(response.profile.posts_in_favoriteforum / response.profile.realposts * 100)}}% от всех сообщений этого пользователя )
            </td>
          </tr>
          <tr>
            <td valign="top"><b>Последнее посещение</b></td>
            <td>{{response.profile.last_visit | formatDateDots}}</td>
          </tr>
          <tr>
            <td valign="top"><b>Статус</b></td>
            <td><img style="vertical-align:middle" src="../assets/p_offline.gif" :title="'User is offline'"> (Offline)</td>
          </tr>
        </table>
      </div>

      <div class="profile__borderwrap profile__flex_child">
        <div class="profile__tableheader profile__smallerheader">
          Связь
        </div>
        <table class="profile__table profile__table2" width="100%">
          <tr>
            <td align="center">
              <img style="vertical-align:middle;" src="../assets/profile_aim.gif">
            </td>
            <td>
              <template v-if="response.profile.aim_name">
                {{htmlDecode(response.profile.aim_name)}}
              </template>
              <template v-else>
                <i>Нет данных</i>
              </template>
            </td>
          </tr>
          <tr>
            <td align="center">
              <img style="vertical-align:middle;" src="../assets/profile_yahoo.gif">
            </td>
            <td>
              <template v-if="response.profile.yahoo">
                {{htmlDecode(response.profile.yahoo)}}
              </template>
              <template v-else>
                <i>Нет данных</i>
              </template>
            </td>
          </tr>
          <tr>
            <td align="center">
              <img style="vertical-align:middle;" src="../assets/profile_icq.gif">
            </td>
            <td>
              <template v-if="response.profile.icq_number && response.profile.icq_number.length > 1">
                {{response.profile.icq_number}}
              </template>
              <template v-else>
                <i>Нет данных</i>
              </template>
            </td>
          </tr>
          <tr>
            <td align="center">
              <img style="vertical-align:middle;" src="../assets/profile_msn.gif">
            </td>
            <td>
              <template v-if="response.profile.msnname">
                {{htmlDecode(response.profile.msnname)}}
              </template>
              <template v-else>
                <i>Нет данных</i>
              </template>
            </td>
          </tr>
          <tr>
            <td align="center">
              <img style="vertical-align:middle;" src="../assets/icon_msg_nonew.gif">
            </td>
            <td><a>Отправить личное сообщение</a></td>
          </tr>
          <tr>
            <td align="center">
              <img style="vertical-align:middle;" src="../assets/icon_msg_nonew.gif">
            </td>
            <td>
              <template v-if="showMail">
                <a>{{response.profile.email}}</a>
              </template>
              <template v-else>
                <i>Email скрыт</i> ( <a @click="toggleMail()">показать</a> )
              </template>
            </td>
          </tr>
        </table>
      </div>
    </div>

    <br>
    <div class="profile__flex">
      <div class="profile__borderwrap profile__flex_child">
        <div class="profile__tableheader profile__smallerheader">
          Информация
        </div>
        <table class="profile__table profile__table1" width="100%">
          <tr>
            <td valign="top"><b>Домашняя страница</b></td>
            <td>
              <template v-if="response.profile.website && response.profile.website.startsWith('http://') && response.profile.website.length > 7">
                <a :href="response.profile.website">{{response.profile.website}}</a>
              </template>
              <template v-else>
                <i>Нет данных</i>
              </template>
            </td>
          </tr>
          <tr>
            <td valign="top"><b>Дата рождения</b></td>
            <td>
              <template v-if="response.profile.bday_day > 0">
                {{response.profile.bday_day}}
              </template>
              <template v-if="response.profile.bday_month > 0">
                {{getMonth(response.profile.bday_month)}}
              </template>
              <template v-if="response.profile.bday_year > 0">
                {{response.profile.bday_year}}
              </template>
              <template v-if="response.profile.bday_day == 0 && response.profile.bday_month == 0 && response.profile.bday_year == 0">
                <i>Нет данных</i>
              </template>
            </td>
          </tr>
          <tr>
            <td valign="top"><b>Место жительства</b></td>
            <td>
              <template v-if="response.profile.location && response.profile.location.length > 0">
                {{htmlDecode(response.profile.location)}}
              </template>
              <template v-else>
                <i>Нет данных</i>
              </template>
            </td>
          </tr>
          <tr>
            <td valign="top"><b>Интересы</b></td>
            <td>
              <template v-if="response.profile.interests && response.profile.interests.length > 0">
                <div v-html="response.profile.interests"></div>
              </template>
              <template v-else>
                <i>Нет данных</i>
              </template>
            </td>
          </tr>
          <tr>
            <td valign="top"><b>Награды</b></td>
            <td>
              <template v-if="response.profile.awards > 0">
                <a class="forum__thread_awards" @click.prevent="showAwardsPopup(response.profile.id, response.profile.name, $event)" :href="'javascript: PopAwards('+response.profile.id+')'">{{response.profile.awards}}</a>
              </template>
              <template v-else>
                <i>Нет наград</i>
              </template>
            </td>
          </tr>
        </table>
      </div>

      <div class="profile__borderwrap profile__flex_child">
        <div class="profile__tableheader profile__smallerheader">
          Дополнительная информация
        </div>
        <table class="profile__table profile__table2" width="100%">
          <tr>
            <td align="center">
              <i>Нет данных</i>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <br>

    <div class="profile__borderwrap" style="margin-bottom: 10px;">
      <div class="profile__tableheader profile__smallerheader profile__sign">
        Подпись
      </div>
      <table class="profile__table profile__table2" width="100%">
        <tr>
          <td>
            <div v-html="fixVariousTags(fixRpgplanetLinks(response.profile.signature))"></div>
          </td>
        </tr>
      </table>
    </div>

    <FooterPermanent v-if="footerReady" :loadTime="loadTime" :totalRequests="response.queries" />
  </template>
  <template v-else-if="footerReady && !response.profile">
    <div>
      Такого профиля нет.
    </div>
  </template>

</div>
</template>

<script>
import Header from './Header'
import FooterPermanent from './FooterPermanent'
import DraggableDiv from './DraggableDiv'

export default {
  components: {
    DraggableDiv,
    Header,
    FooterPermanent
  },
  data: function() {
    return {
      response: null,
      footerReady: false,
      showMail: false,
      awards: null,
      awardsname: null,
    }
  },
  async created() {
    console.time("PageLoadTime");
    let dateEarly = new Date();
    let userid = 0;
    if (this.$route.query.showuser) {
      userid = Number(this.$route.query.showuser);
    }
    let response = await fetch(this.getNodePath() + 'misc/profile/' + userid);
    let dateLater = new Date();
    this.response = await response.json();
    this.loadTime = this.spanSeconds(dateEarly, dateLater);
    this.footerReady = true;
    console.timeEnd("PageLoadTime");
  },
  methods: {
    toggleMail(addr) {
      this.showMail = true;
    },
    getMonth(month) {
      const MONTHS = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];
      return MONTHS[month + 1];
    },
    hideAwardsPopup() {
      let awardsBlock = document.getElementById("thread__awards");
      awardsBlock.style.display = "none";
      this.awards = null;
      this.awardsname = null;
    },
    async showAwardsPopup(posterid, postername, event) {
      this.hideAwardsPopup();
      this.awardsname = postername;
      let awardsBlock = document.getElementById("thread__awards");
      awardsBlock.style.display = "block";
      awardsBlock.style.top = event.pageY - 220 + "px";
      awardsBlock.style.left = "255px";
      let awardsResponse = null;
      posterid = Number(posterid);
      awardsResponse = await fetch(this.getNodePath() + 'misc/awards/' + posterid);
      this.awards = await awardsResponse.json();
    },
  },
  filters: {
    consumeN: function(number) {
      return "*";
    }
  }
}
</script>

<style lang="scss">
@import "./Profile.scss";
</style>
